import { render, staticRenderFns } from "./AltaGestionPuntual.vue?vue&type=template&id=cbd54b34"
import script from "./AltaGestionPuntual.vue?vue&type=script&lang=js"
export * from "./AltaGestionPuntual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports